/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_HereInputs */

const en_auth_login_here = /** @type {(inputs: Auth_Login_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login here`)
};

const es_auth_login_here = /** @type {(inputs: Auth_Login_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión aquí`)
};

/**
* | output |
* | --- |
* | "Login here" |
*
* @param {Auth_Login_HereInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_login_here = /** @type {((inputs?: Auth_Login_HereInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_HereInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_login_here(inputs)
	return en_auth_login_here(inputs)
});